// @ts-nocheck

import React, { useState } from 'react';
import styled from 'styled-components';

import { __ } from '../../i18n/l10n';
import theme from '../../styled-components/dark';
import BasketCombinationsSelectorContainer from '../BasketCombinationsSelector/BasketCombinationsSelectorContainer';
import BasketCombinationsSummaryContainer from '../BasketCombinationsSummary/BasketCombinationsSummaryContainer';
import OverModal from '../OverModal';

const StyledBasketCombinationsSelectorContainer = styled(BasketCombinationsSelectorContainer)`
  padding: 0.6em;
`;

const ModalSystemCombinations = styled(BasketCombinationsSelectorContainer)`
  padding: 0.6em;

  border-top-left-radius: 1em;
  border-top-right-radius: 1em;
  background-color: ${theme.BasketSystems.mobileBackgroundColor};
`;

const StyledBasketCombinationsSummaryContainer = styled(BasketCombinationsSummaryContainer)`
  padding: 0.6em 0.6em 0;
`;

type BasketSystemsProps = {
  shouldOpenModal: boolean;
  readOnly: boolean;
};

const BasketSystems = ({ shouldOpenModal, readOnly }: BasketSystemsProps) => {
  const [isEdit, setIsEdit] = useState(false);

  if (shouldOpenModal) {
    return (
      <>
        <StyledBasketCombinationsSummaryContainer
          headerLabel={__('Combinations')}
          onUpdateButtonClick={!readOnly ? () => setIsEdit(true) : null}
        />
        <OverModal isOpen={isEdit} onClose={() => setIsEdit(false)}>
          <ModalSystemCombinations readOnly={readOnly} onSubmit={() => setIsEdit(false)} />
        </OverModal>
      </>
    );
  }

  return <StyledBasketCombinationsSelectorContainer readOnly={readOnly} />;
};

export default BasketSystems;
